export default __webpack_public_path__ + "static/rsz_logo-my3miasto-76facfc8e5093bb27fc3a4894f35b54f.png";